export default "/images/vendor/flag-icon-css/flags/1x1/aw.svg?b478dded01c70ad2275c32a83c4f818d";